/**
 * 删除字符串前置零
 *
 * @param str
 */
export const removeFrontZone = (str: string) => str.replace(/\b(0+)/gi, '');

/**
 * 补充前置零
 *
 * @param str
 */
export const pushFrontZone = (str: string) => (Array(18).join('0') + str).slice(-18);

/**
 * 间隔插入字符
 *
 * @param str
 * @param interval
 * @param block
 */
export const insertString = (str: string, interval: number, block: string) => {
  if (interval <= 0) return str;
  const arr = [];
  const length = Math.ceil(str.length / interval);
  for (let i = 0; i < length; i += 1) {
    arr.push(str.substr(i * interval, interval));
  }
  return arr.join(block);
};
